(function () {
  var nav = document.getElementById('lc-main-nav');
  if (!nav) return;

  // Horizon's own CSS (assets/base.css) makes `.page-wrapper` the actual
  // scrolling container at desktop widths (>=990px) instead of the
  // window — `html`/`body` get `overflow: hidden` there. So the real
  // scroll position can live on either the window (mobile) or
  // `.page-wrapper` (desktop); read whichever is actually scrolling.
  var scroller = document.querySelector('.page-wrapper');

  var THRESHOLD = 140;
  var stuck = false;
  var ticking = false;

  function getScrollY() {
    var windowY = window.scrollY || document.documentElement.scrollTop || 0;
    var wrapperY = scroller ? scroller.scrollTop : 0;
    return Math.max(windowY, wrapperY);
  }

  var FADE_MS = 160;
  var swapping = false;

  function update() {
    ticking = false;
    var shouldStick = getScrollY() > THRESHOLD;
    if (shouldStick === stuck || swapping) return;
    stuck = shouldStick;

    // `position`, `top` and `left` can't be transitioned smoothly (the
    // nav jumps from in-flow to fixed-and-centered in one step), so the
    // swap is hidden behind a quick fade instead of happening in plain
    // sight — fade out, swap the layout while invisible, fade back in.
    swapping = true;
    nav.style.transition = 'opacity ' + FADE_MS + 'ms ease';
    nav.style.opacity = '0';

    window.setTimeout(function () {
      nav.classList.toggle('lc-stuck', stuck);
      // Force a reflow so the opacity transition below doesn't get
      // batched together with the class-change layout jump.
      void nav.offsetHeight;
      nav.style.opacity = '1';
      window.setTimeout(function () {
        swapping = false;
        update();
      }, FADE_MS);
    }, FADE_MS);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  if (scroller) {
    scroller.addEventListener('scroll', onScroll, { passive: true });
  }
  update();
})();
